import { useQuery } from '@tanstack/react-query';

import { listSkills } from '@/services/skills';
import { useOrgStore } from '@/stores/org-store';

export function useSkillList(enabled = true) {
  const orgId = useOrgStore((state) => state.currentOrg?.orgid);

  return useQuery({
    queryKey: ['skills', orgId],
    queryFn: listSkills,
    enabled: !!orgId && enabled,
  });
}
